import {
  Badge,
  DataTableFilters,
  DataTableSearch,
  useTableContext,
} from "@bleu.builders/ui";
import React from "react";

import { ThesesGroupOptions } from "./ThesesGroupOptions";

export function calculateOpportunities(data) {
  if (!data) {
    return 0;
  }

  const itemsCount = {};
  data.data.forEach((item) => {
    itemsCount[item.id] = 1;
  });

  return Object.keys(itemsCount).length;
}

export function ThesesTableToolbar({ showGroupOptions, actions }) {
  // @ts-ignore-next-line
  const { data, tableState, setTableState } = useTableContext();

  return (
    <div className="flex justify-between items-end">
      <div className="flex justify-start gap-5 items-center">
        <div className="flex flex-col">
          <div className="flex justify-between">
            <span className="text-base font-medium">Buscar</span>
            <Badge className="bg-orange-600/60 hover:bg-orange-600/50 my-0.5">
              {calculateOpportunities(data)} Teses disponíveis
            </Badge>
          </div>
          <DataTableSearch />
        </div>
        {showGroupOptions && (
          <div className="flex flex-col">
            <span className="text-base font-medium">Visualizar</span>
            <ThesesGroupOptions
              tableState={tableState}
              setTableState={setTableState}
            />
          </div>
        )}
        <div className="flex flex-col">
          <span className="text-base font-medium">Filtrar</span>
          <DataTableFilters />
        </div>
      </div>
      {actions}
    </div>
  );
}
